import { initials } from './lib.js'

/** Small monochrome initials badge — who logged this session. */
export default function Initials({ name }) {
  const txt = initials(name)
  if (!txt) return null
  return (
    <span
      title={name}
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-hairline bg-white text-[10px] font-semibold text-muted"
    >
      {txt}
    </span>
  )
}
